import { api } from 'app/config/apiConfig';
import { RentOptionDocument } from '../model/types';
import { UserAccountType } from 'entities/User';

interface Params {
  warehouseId?: string;
  accountType?: UserAccountType;
  isSpecialPromotion?: boolean;
  showAsPromotion?: boolean;
}

export const getRentOptionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRentOptions: build.query<RentOptionDocument[], Params | void>({
      query: (params) => ({
        url: '/contracts/rent/rent-options',
        params: params || undefined,
      }),
    }),
  }),
});

export const { useGetRentOptionsQuery } = getRentOptionsApi;
